import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import HomeLanding from "../views/HomeLanding";
import ArticlesHome from "../views/ArticlesHome";
import ConfessionsHome from "../views/ConfessionsHome";

export default function Home(props) {

  const appContext = useContext(AppContext);

  const [ view, setView ] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if(
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <HomeLanding/>
    } else if(
      appContext.navSubItem === 'articles' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ArticlesHome/>
    } else if(
      appContext.navSubItem === 'confessions' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ConfessionsHome/>
    } 

    return null;
  }

  useEffect(() => {
    init();
  }, [ ])

  useEffect(() => {
    const _view = getView();
    if(_view) {
      setView(_view);
    }
  }, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

  //return desired view
  return view;
}